<template>
  <div>
    <!--    <h3>Domains</h3>-->
    <v-toolbar color="primary"
      dark>
      <v-toolbar-title>Domain Pricing</v-toolbar-title>
    </v-toolbar>
    <v-card min-height="calc(100vh - 150px)">
      <div>
        <template>
          <v-card-text>
            <v-data-table :headers="tableHeaders"
              hide-default-header
              hide-default-footer
              :items="domainsList"
              :loading="isDataLoading"
              :item-class="itemClass"
              :search="searchQuery"
              :items-per-page="100"
              @toggle-select-all="handleSelectAllDomainsEvent"
              @item-selected="handleSelectDomainEvent"
              :selectable-key="'id'"
              dense
              :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [10, 25, 50, 100, 200, 500],
                'items-per-page-text': 'Rows per page:'
              }"
              :options.sync="pagination"
              :server-items-length="totalNumberOfItems"
              show-select
              class="custom_table domains">
              <template #header="data">
                <thead class="v-data-table-header"
                  v-show="!data.props.mobile">
                  <tr>
                    <th v-for="(header_item, index) in data.props.headers"
                      :key="'header_item' + index"
                      v-on="data.on"
                      :style="{
                        borderRight: header_item.divider
                          ? 'lightgrey solid 1px'
                          : 'none'
                      }"
                      :class="header_item.class">
                      <div v-if="header_item.value == 'data-table-select'">
                        <v-checkbox :indeterminate="data.props.someItems != data.props.everyItem
                          "
                          :key="data.props.someItems + data.props.everyItem"
                          dense
                          hide-details
                          style="margin-top: 0"
                          class="margin-right-14p"
                          v-model="data.props.everyItem"
                          @change="
                            data.on['toggle-select-all'](data.props.everyItem)
                            " />
                      </div>
                      <div :style="{width: '100%', justifyContent: header_item.align && (header_item.align == 'left' ? 'flex-start !important' : header_item.align == 'center' ? 'center!important' : 'flex-end !important')}">
                          <div style="flex: 1;  cursor: pointer;" class="hover-shows"
                              >
                              {{ header_item.text }}
                          </div>
                          <div style="align-self: center">
                              <v-icon v-if="header_item.sortable !== false"
                                  @click="() => {data.on.sort(header_item.value)}" size="10">
                                  fas fa-sort
                              </v-icon>
                          </div>
                      </div>
                    </th>
                  </tr>
                </thead>
              </template>
              <template #footer="{ props }">
                <div style="text-align: right;margin-top: 10px;">
                  <div style="display: flex; position: absolute; right: 20px">
                    <div class="mob_hide mt-2 mr-2">
                      {{ props.itemsPerPageText }}
                    </div>
                    <div style="width: 60px"
                      class="mr-2">
                      <v-select :items="props.itemsPerPageOptions"
                        v-model="props.options.itemsPerPage"
                        v-on:change="handleItemsPerPageChanged"
                        outlined
                        class="page-select"></v-select>
                    </div>
                    <div class="mt-2 mr-2">
                      <span class="ml-2 mr-2">&#9474;</span>
                      {{ props.pagination.pageStart }}~{{
                        props.pagination.pageStop
                      }}
                      of {{ props.pagination.itemsLength }}
                      <span class="ml-2 mr-2">&#9474;</span>
                    </div>
                    <div class="mob_hide mt-2 mr-2">
                      Page:
                    </div>
                    <div>
                      <div style="width: 50px">
                        <v-select :items="new Array(props.pagination.pageCount)
                          .fill(0)
                          .map((val, ind) => ind + 1)
                          "
                          outlined
                          v-model="props.options.page"
                          v-on:change="handlePageNumberChanged"
                          class="page-select"></v-select>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:top>
                <div>
                  <div style="display: flex;flex-wrap: wrap"
                    v-show="showColumnSetting"
                    class="mb-1">
                    <div v-for="(item, index) in headers"
                      :key="'headeritem' + index"
                      class="mx-2">
                      <v-checkbox dense
                        hide-details
                        v-model="item.is_show"
                        :label="item.text"
                        class="custom-checkbox my-0" />
                    </div>
                  </div>
                  <div style="display: flex;flex-wrap: wrap; align-items: center">
                    <div class="tablet_hide" style="align-self: center;display: flex">
                      <div class="mr-1">
                        <v-text-field v-model="searchQuery"
                          placeholder="Search"
                          dense
                          height="36"
                          hide-details
                          outlined>
                          <template #append>
                            <div>
                              <t-icon name="Search" />
                            </div>
                          </template>
                        </v-text-field>
                      </div>
                      <div style="width: 160px"
                        class="mr-1">
                        <v-select label="Catch Date"
                          v-model="domain_catch_date"
                          outlined
                          dense
                          hide-details
                          :items="[
                            { value: 0, text: '-' },
                            { value: 1, text: 'Today' },
                            { value: 2, text: 'Tomorrow' },
                            { value: 3, text: 'Next 5 Days' },
                            { value: 4, text: 'Next 7 Days' },
                            { value: 5, text: 'Next 30 Days' },
                            { value: 6, text: 'All' }
                          ]">
                        </v-select>
                      </div>
                      <div style="width: 180px"
                        class="mr-1">
                        <v-select label="Source"
                          v-model="domain_source"
                          outlined
                          dense
                          hide-details
                          :items="domain_source_items">
                        </v-select>
                      </div>
                      <div style="width: 160px"
                        class="mr-1">
                        <v-select label="Type"
                          v-model="domain_type"
                          outlined
                          dense
                          hide-details
                          :items="[
                            { value: 0, text: '-' },
                            { value: 1, text: 'SEO' },
                            { value: 2, text: 'Brandable' },
                            { value: 3, text: 'LL' },
                            { value: 4, text: 'LLL' },
                            { value: 5, text: 'Others' },
                            { value: 6, text: 'All' }
                          ]">
                        </v-select>
                      </div>
                      <div style="width: 170px">
                        <v-select label="Default Sort"
                          v-model="default_sort"
                          outlined
                          dense
                          @change="sortChange($event)"
                          hide-details
                          :items="[
                            { value: 'dropDate', text: 'Drop Date' },
                            { value: 'source', text: 'Source' },
                            { value: 'finalBidPrice', text: 'Bid Price' },
                            { value: 'bidCount', text: 'Bid Count' },
                            { value: 'domainAuthority', text: 'DA' },
                            { value: 'priority', text: 'Priority' }
                          ]">
                        </v-select>
                      </div>
                    </div>
                    <div style="display: flex; justify-content: flex-end; flex: 1; align-self: center;"
                      class="py-1 mob_flex-wrap">
                      <div class="tablet_show mx-1">
                        <v-btn icon @click="(filterDialog = true)">
                          <v-icon dark size="16">
                              mdi-filter-outline
                          </v-icon>
                        </v-btn>
                      </div>
                      <v-menu offset-y
                        :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn color="primary"
                            icon
                            v-bind="attrs"
                            v-on="on">
                            <t-icon name="Column Chooser Icon" />
                          </v-btn>
                        </template>
                        <v-list class="fields-show">
                          <div v-for="(item, index) in headers"
                            :key="'headeritem' + index"
                            class="px-4">
                            <v-checkbox dense
                              v-if="item.text"
                              v-model="item.is_show"
                              :label="item.text"
                              class="custom-checkbox my-0" />
                          </div>
                        </v-list>
                      </v-menu>
                      <v-btn class="mx-1"
                        icon>
                        <t-icon name="refresh" />
                      </v-btn>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:item.catch_date="{ item }">
                {{ getReadableMonth(item) }}
              </template>
              <template v-slot:item.dropDate="{ item }">
                <!-- {{ formatDate(item.dropDate) }} -->
                {{ converDropDate(item) }}
              </template>
              <template v-slot:item.addedDate="{ item }">
                {{ formatDate(item.addedDate) }}
              </template>
              <template v-slot:item.finalBidPrice="{ item }">
                {{
                  item.finalBidPrice >= 0
                  ? item.finalBidPrice + " GBP"
                  : "-"
                }}
              </template>
              <template v-slot:item.type="{ item }">
                <v-select dense
                  hide-details
                  :items="[
                    { value: 0, text: '-' },
                    { value: 1, text: 'SEO' },
                    { value: 2, text: 'Brandable' },
                    { value: 3, text: 'LL' },
                    { value: 4, text: 'LLL' },
                    { value: 5, text: 'Others' }
                  ]"
                  outlined
                  v-model="item.type"
                  class="custom_select width-100p left-aligned-page-select"
                  @input="handleUpdateDomainTypeEvent(item)"></v-select>
              </template>
              <template v-slot:item.priority="{ item }">
                <v-select dense
                  hide-details
                  outlined
                  :items="[
                    { value: 1, text: '1' },
                    { value: 2, text: '2' },
                    { value: 3, text: '3' },
                    { value: 4, text: '4' },
                    { value: 5, text: '5' }
                  ]"
                  v-model="item.priority"
                  class="custom_select width-40p left-aligned-page-select"
                  @input="updateDomainPriority(item)"></v-select>
              </template>
              <template v-slot:item.bidCount="{ item }">
                <div v-if="item.bidCount == 0">
                  -
                </div>
                <div v-else>
                  {{ item.bidCount }}
                </div>
              </template>
              <template v-slot:item.statusMessage="{ item }">
                {{ statusMessage(item.statusMessage) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div class="actionsForReviewDomain" color="#6f95ed">
                  <v-btn class="mx-1 action-button" @click="handleDeleteDomain(item)" fab
                    dark x-small title="Delete" color="red">
                    <v-icon dark>
                        mdi-trash-can-outline
                    </v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>


          </v-card-text>
        </template>
      </div>
    </v-card>
    <v-dialog v-model="dialog"
      max-width="420">
      <v-card>
        <v-toolbar color="#28a2ff"
          dark
          height="50px"
          min-height="50px">
          <v-toolbar-title>
            <div>{{ formTitle }}</div>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon
            small
            @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div v-if="formTitle == 'Add List'"
            class="custom_center pt-3">
            <v-row>
              <v-col>
                <v-textarea rows="12"
                  v-model="domainList.list"
                  outlined
                  hide-details />
              </v-col>
              <v-col md="12"
                class="pt-0 pb-0">
                <strong class="fs-15">Format: </strong><span class="fs-15"> Domain,Priority</span>
                <div style="font-size: 13px">
                  Demo 1: abc.org.uk,1<br />
                  Demo 2: abc.org.uk<br />
                  <strong>Note: </strong> If not priority set, it will default to priority 3.
                </div>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="domainList.source"
                  dense
                  hide-details
                  class="custom_input"
                  label="Source"
                  outlined>
                </v-text-field>
              </v-col>
            </v-row>
            <div style="text-align: center"
              class="pb-3">
              <v-btn class="mx-1"
                @click="addDomainList"
                color="primary"
                :loading="domainListAdding">
                Add
              </v-btn>
            </div>
          </div>
          <div v-if="formTitle == 'Add New'"
            class="custom_center">
            <v-row style="margin-top: 25px">
              <v-col cols="12">
                <v-text-field v-model="domainItem.domain"
                  label="Domain"
                  outlined
                  dense
                  hide-details
                  class="custom_input">
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Source"
                  outlined
                  v-model="domainItem.source"
                  dense
                  hide-details
                  class="custom_input">
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select label="Type"
                  v-model="domainItem.type"
                  outlined
                  dense
                  hide-details
                  class="custom_input"
                  :items="[
                    { value: 0, text: '-' },
                    { value: 1, text: 'SEO' },
                    { value: 2, text: 'Brandable' },
                    { value: 3, text: 'LL' },
                    { value: 4, text: 'LLL' },
                    { value: 5, text: 'Others' },
                    { value: 6, text: 'All' }
                  ]">
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-select label="Priority"
                  dense
                  :items="[
                    { value: 1, text: '1' },
                    { value: 2, text: '2' },
                    { value: 3, text: '3' },
                    { value: 4, text: '4' },
                    { value: 5, text: '5' }
                  ]"
                  outlined
                  v-model="domainItem.priority"
                  class="custom_input">
                </v-select>
              </v-col>
              <v-col>
                <v-textarea rows="5"
                  v-model="domainItem.note"
                  outlined
                  hide-details
                  placeholder="Add your notes" />
              </v-col>
            </v-row>
            <div style="text-align: center"
              class="py-3">
              <v-btn class="mx-1"
                @click="addDomain"
                color="primary"
                :loading="domainListAdding">
                Add Domain
              </v-btn>
            </div>
          </div>
          <div v-if="formTitle == 'Edit Domain'"
            class="custom_center">
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="domainItem.domain"
                  dense
                  class="custom_input"
                  label="Domain"
                  outlined>
                </v-text-field>
                <v-select label="Priority"
                  dense
                  :items="[
                    { value: 1, text: '1' },
                    { value: 2, text: '2' },
                    { value: 3, text: '3' },
                    { value: 4, text: '4' },
                    { value: 5, text: '5' }
                  ]"
                  outlined
                  v-model="domainItem.priority">
                </v-select>
                <v-menu ref="menu"
                  :close-on-content-click="false"
                  :return-value.sync="domainItem.catchDate"
                  transition="scale-transition"
                  offset-y
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="domainItem.catchDate"
                      label="Catch Date"
                      prepend-inner-icon="mdi-calendar"
                      dense
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="domainItem.catchDate"
                    no-title
                    scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text
                      color="primary">
                      Cancel
                    </v-btn>
                    <v-btn text
                      color="primary"
                      @click="$refs.menu.save(domainItem.catchDate)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-textarea rows="6"
                  v-model="domainItem.notes"
                  outlined
                  label="Notes"
                  hide-details />
              </v-col>
            </v-row>
            <div style="text-align: center"
              class="py-3">
              <v-btn class="mx-1"
                @click="updateDomain"
                color="primary"
                :loading="domainListAdding">
                <!-- <t-icon name="edit" />  -->
                Update
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="filterDialog" max-width="420">
      <v-card>
        <v-toolbar color="#28a2ff" dark height="50px" min-height="50px">
          <v-toolbar-title>
            <div>Filter</div>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon small @click="filterDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-6 pt-3">
          <div class="mt-5">
            <v-text-field v-model="searchQuery"
              placeholder="Search"
              dense
              height="36"
              hide-details
              outlined>
              <template #append>
                <div>
                  <t-icon name="Search" />
                </div>
              </template>
            </v-text-field>
          </div>
          <div class="mt-5">
            <v-select label="Catch Date"
              v-model="domain_catch_date"
              outlined
              dense
              hide-details
              :items="[
                { value: 0, text: '-' },
                { value: 1, text: 'Today' },
                { value: 2, text: 'Tomorrow' },
                { value: 3, text: 'Next 5 Days' },
                { value: 4, text: 'Next 7 Days' },
                { value: 5, text: 'Next 30 Days' },
                { value: 6, text: 'All' }
              ]">
            </v-select>
          </div>
          <div class="mt-5">
            <v-select label="Source"
              v-model="domain_source"
              outlined
              dense
              hide-details
              :items="domain_source_items">
            </v-select>
          </div>
          <div class="mt-5">
            <v-select label="Type"
              v-model="domain_type"
              outlined
              dense
              hide-details
              :items="[
                { value: 0, text: '-' },
                { value: 1, text: 'SEO' },
                { value: 2, text: 'Brandable' },
                { value: 3, text: 'LL' },
                { value: 4, text: 'LLL' },
                { value: 5, text: 'Others' },
                { value: 6, text: 'All' }
              ]">
            </v-select>
          </div>
          <div class="mt-5">
            <v-select label="Default Sort"
              v-model="default_sort"
              outlined
              dense
              @change="sortChange($event)"
              hide-details
              :items="[
                { value: 'dropDate', text: 'Drop Date' },
                { value: 'source', text: 'Source' },
                { value: 'finalBidPrice', text: 'Bid Price' },
                { value: 'bidCount', text: 'Bid Count' },
                { value: 'domainAuthority', text: 'DA' },
                { value: 'priority', text: 'Priority' }
              ]">
            </v-select>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import RestService from '../services/rest.service'
import moment from 'moment'
import Vue from 'vue'
import {getDropDate} from '../utils/extra'

export default {
  name: 'Domains',
  data: () => ({
    showColumnSetting: false,
    all: 'All',
    domain_type: 6,
    domain_source: 3,
    default_sort: 'dropDate',
    domain_source_items: [
      { value: 0, text: 'HostedChasing' },
      { value: 1, text: 'Dictionary' },
      { value: 2, text: 'DL Other' },
      { value: 3, text: 'All' }
    ],
    domain_catch_date: 6,
    domainItem: {
      source: '',
      domain: '',
      note: '',
      type: '',
      priority: 3,
      catchDay: (new Date()).getDate(),
      catchMonth: (new Date()).getMonth() + 1,
      catchYear: (new Date()).getFullYear()
    },
    selectedDomain: [],
    domainList: {
      source: '',
      list: ''
    },
    searchQuery: '',
    formTitle: 'Add List',
    dialog: false,
    filterDialog: false,
    isDataLoading: false,
    totalNumberOfItems: 0,
    pagination: {},
    headers: [
      {
        text: "Domain",
        value: "domain",
        divider: false,
        is_show: true,
        align: 'left',
        width: "100px",
        sortable: true
      },
      {
        text: "Date Caught",
        value: "addedDate",
        divider: true,
        is_show: true,
        width: "75px",
      },
      {
        text: "Source",
        value: "source",
        width: "70px",
        divider: false,
        align: 'center',
        is_show: true,
      },
      {
        text: "Type",
        value: "type",
        divider: true,
        is_show: true,
        align: 'center',
        width: "60px",
      },
      {
        text: "Bid Count",
        value: "bidCount",
        divider: false,
        align: 'center',
        is_show: true,
        width: "60px",
        fixed: true,
      },
      {
        text: "Bid Price",
        value: "finalBidPrice",
        divider: false,
        align: 'center',
        is_show: true,
        width: "80px",
        fixed: true,
      },
     
      {
        text: "Year",
        value: "year",
        divider: false,
        is_show: true,
        width: "40px",
      },
      {
        text: "MOZ DA",
        value: "domainAuthority",
        divider: true,
        align: 'center',
        is_show: true,
        width: "50px",
      },
     
      {
        text: "TAG",
        value: "statusMessage",
        divider: true,
        width: "60px",
        is_show: false,
      },
      {
        text: "Sold Price",
        value: "soldPrice",
        divider: false,
        width: "60px",
        is_show: true,
      },
      {
        text: "Date Sold",
        value: "dateSold",
        divider: true,
        width: "60px",
        is_show: true,
      },
      {
        text: "Platform",
        value: "platform",
        divider: true,
        width: "60px",
        is_show: true,
      },
      {
        text: "Winner Username",
        value: "winnerUserName",
        divider: false,
        width: "60px",
        align: 'center',
        is_show: true,
      },
      {
        text: "",
        value: "actions",
        sortable: false,
        is_show: true,
        width: "30px",
      },
    ],
    domains: [],
    originDomains: [],
    editedIndex: -1,
    domainListAdding: false
  }),
  computed: {
    currentUser() {
      return this.$store.state.auth.user
    },
    tableHeaders() {
      return this.headers.filter(x => x.is_show == true)
    },
    originalDomainsList() {
      return [...this.domains];
    },
    domainsList() {
      let data = this.domains
      const currentDate = new Date()
      const limitDate = currentDate.setDate(currentDate.getDate() - 1)

       // data = data.filter(x => {
      //   if(x.dropDate){
      //     if(new Date(x.dropDate) > new Date(limitDate)){
      //       return x;
      //     }
      //   }else{
      //     return x;
      //   }
      // } )


      if (this.domain_type != 0 && this.domain_type != 6) {
        data = data.filter(x => x.type == this.domain_type)
      }

      if (this.domain_source != 3) {
        const index = this.domain_source_items.findIndex(item => item.value == this.domain_source)
        data = data.filter(x => x.source == this.domain_source_items[index].text)

      }

      const c_date = new Date()

      const year = c_date.getFullYear()
      const month = c_date.getMonth() + 1
      const day = c_date.getDate()

      if (this.domain_catch_date == 1) {
        data = data.filter(
          x => x.catchYear == year && x.catchMonth == month && x.catchDay == day
        )
      }
      if (this.domain_catch_date == 2) {
        c_date.setDate(day + 1)

        data = data.filter(
          x => x.catchYear == year && x.catchMonth == month && x.catchDay == day
        )
      }
      if (this.domain_catch_date == 3) {
        c_date.setDate(day + 5)

        data = data.filter(
          x =>
            x.catchYear == year &&
            ((x.catchMonth == month && x.catchDay <= day) ||
              (x.catchMonth == month + 1 && x.catchDay <= day))
        )
      }
      if (this.domain_catch_date == 4) {
        c_date.setDate(day + 7)

        data = data.filter(
          x =>
            x.catchYear == year &&
            ((x.catchMonth == month && x.catchDay <= day) ||
              (x.catchMonth == month + 1 && x.catchDay <= day))
        )
      }
      if (this.domain_catch_date == 5) {
        c_date.setDate(day + 30)

        data = data.filter(
          x =>
            x.catchYear == year &&
            ((x.catchMonth == month && x.catchDay <= day) ||
              (x.catchMonth == month + 1 && x.catchDay <= day))
        )
      }

      return data
    }
  },
  watch: {
    pagination: {
      async handler() {
        this.getTableData();

      },
      deep: true
    },
    searchQuery() {
      const query = this.searchQuery.toLowerCase();
      console.log(query)
      this.domains = this.originDomains.filter((item) => {
        for (const header of this.tableHeaders) {
          if (
            String(item[header.value])
              .toLowerCase()
              .includes(query)
          ) {
            return true;
          }
        }
        return false;
      });
    },
  },
  methods: {
    converDropDate(item) {
      const dropDate = getDropDate(item.catchYear, item.catchMonth, item.catchDay, item.catchHour, item.catchMinute, item.catchSecond)
      return dropDate
    },
    getTableData(default_sort) {
      this.isDataLoading = true

      const { sortBy, page, itemsPerPage } = this.pagination
      console.log(sortBy[0])
      let sort;
      if (default_sort) {
        sort = this.default_sort
      } else if (sortBy[0]) {
        sort = sortBy[0]
      } else {
        sort = this.default_sort
      }

      const pageNumber = page - 1
      const filter = {
        pageNo: pageNumber,
        pageSize: itemsPerPage,
        sortBy: sort
      }
      const queryParams = '?pageNo=' + pageNumber + '&pageSize=' + itemsPerPage + '&sortBy=' + sort + '&direction=' + this.pagination.sortDesc

      return RestService.post(process.env.VUE_APP_APIURL + /* 'drops-domains' */ 'domain-pricing' + queryParams, JSON.stringify(filter))
        .then(({ data }) => {
          this.isDataLoading = false

          this.domains = data.domains
          this.originDomains = data.domains
          this.totalNumberOfItems = data.totalItemsCount
        },
          (e) => {
            this.isDataLoading = false
            this.error = e.message
          })

    },
    changeStatusToQueue: async function (domain) {
      // First assume that we have only one domain to update.
      let updateDomains = [domain]

      // Check if we have multiple domains to update and handle this case.
      if (this.selectedItems.length > 1) {
        updateDomains = this.selectedItems
      }

      for (let i = 0; i < updateDomains.length; i++) {
        const updateDomain = updateDomains[i]
        updateDomain.statusCode = domain.statusCode

        await this.updateDomainStateToQueue(updateDomain)
      }
    },
    sortChange(event) {
      this.getTableData(event)
      this.domain_type = 6
      this.domain_source = 3
      this.domain_catch_date = 6
    },
    itemClass(item) {
      return item.excludeFromCatching === true ? 'excludeFromCatching' : ''
    },
    async updateDomainTypeFetch(domain) {
      const url = process.env.VUE_APP_APIURL + 'domains/update_type'
      RestService.post(url, JSON.stringify(domain))
        .then((result) => {
          if (!result.data.result) {
            alert(result.data.message)
          }
          if (result.data.result) {
            Vue.notify({
              title: 'Update domain type for ' + domain.domain,
              text: result.message
            })
          } else {
            Vue.notify({
              title: 'Error on update domain type',
              text: result.message,
              type: 'error'
            })
          }
        },
          (e) => {
            console.log(e)
            this.error = 'Server Error.'
          }
        )
    },
    handleUpdateDomainTypeEvent: async function (domain) {
      // First assume that we have only one domain to update.
      let updateDomains = [domain]

      // Check if we have multiple domains to update and handle this case.
      if (this.selectedDomain.length > 1) {
        updateDomains = this.selectedDomain
      }

      for (let i = 0; i < updateDomains.length; i++) {
        const updateDomain = updateDomains[i]
        updateDomain.type = domain.type

        await this.updateDomainTypeFetch(updateDomain)
      }
    },
    updateDomain: async function () {
      if (this.domainItem.catchDate != undefined) {
        const catchDate = new Date(this.domainItem.catchDate)
        this.domainItem.catchYear = catchDate.getFullYear()
        this.domainItem.catchMonth = catchDate.getMonth() + 1
        this.domainItem.catchDay = catchDate.getDate()
      }
      RestService.post(process.env.VUE_APP_APIURL + 'domains/update', JSON.stringify(this.domainItem))
        .then((result) => {
          if (!result.data.result) {
            alert(result.data.message)
          } else {
            const index = this.domains.findIndex(x => x.id == this.domainItem.id)
            this.domains[index] = Object.assign(
              this.domains[index],
              this.domainItem
            )
            this.dialog = false
          }
        },
          (e) => {
            console.log(e)
            this.error = 'Server Error.'
          }
        )
    },
    addDomain: async function () {
      this.domainListAdding = true
      this.domainItem.catchYear = (new Date()).getFullYear()
      this.domainItem.catchMonth = (new Date()).getMonth() + 1
      this.domainItem.catchDay = (new Date()).getDate()

      RestService.post(process.env.VUE_APP_APIURL + 'domains/add', JSON.stringify(this.domainItem))
        .then((result) => {
          if (!result.data.result) {
            alert(result.data.message)
            this.domainListAdding = false
            getTableData()
            return
          }
          this.domainListAdding = false
          this.dialog = false
        },
          (e) => {
            console.log(e)
            this.error = 'Server Error.'
          }
        )
    },
    async handleDeleteDomain(domain){
      console.log(domain)
      let confirmationMessage = 'Are you sure you want to delete this domain?'
        let deleteDomains = [domain]

        // Check if we have multiple domains to delete and handle this case.
        if (this.selectedDomain.length > 1) {
            confirmationMessage = 'Are you sure you want to delete this items?'

            deleteDomains = this.selectedDomain
        }

        if (confirm(confirmationMessage)) {
            for (let i = 0; i < deleteDomains.length; i++) {
                await this.deleteDomainFetch(deleteDomains[i])
            }

            this.selectedDomain = []
        }
    },
    async deleteDomainFetch(domain) {
      RestService.post(process.env.VUE_APP_APIURL + 'drops-domain/delete', '' + domain.id)
        .then((result) => {
            if (result.data.result) {
                this.deleteFromDomains(domain)
                Vue.notify({
                    title: 'Delete domain ' + domain.domain,
                    text: result.data.message
                })
            } else {
                Vue.notify({
                    title: 'Error on delete domain',
                    text: result.data.message,
                    type: 'error'
                })
            }
          },
            (e) => {
                console.log(e)
                this.error = 'Server Error.'
            }
        )
    },
    async priorityFetch(domain) {
      RestService.post(process.env.VUE_APP_APIURL + 'domains/update_priority', JSON.stringify(domain)).then(
        (result) => {
          if (!result.data.result) {
            alert(result.data.message)
          }
        },
        (e) => {
          console.log(e)
          this.error = 'Server Error.'
        }
      )
    },
    updateDomainPriority(domain) {
      if (this.selectedDomain.length) {
        var include = this.selectedDomain.filter(dom => dom.id === domain.id)
        if (include.length) {
          this.selectedDomain.map(domain => {
            this.priorityFetch(domain)
          })
        } else {
          this.priorityFetch(domain)
        }
      } else {
        this.priorityFetch(domain)
      }
    },
    getReadableMonth: function (domain) {
      /* if (domain.catchMonth === 1 && domain.catchDay === 1 && domain.catchYear === 2500) {
        return 'Not determined yet ...'
      } */
      var month = '' + domain.catchMonth
      var day = '' + domain.catchDay
      if (month.length == 1) {
        month = '0' + domain.catchMonth
      }
      if (day.length == 1) {
        day = '0' + domain.catchDay
      }
      return moment(domain.catchYear + '-' + month + '-' + day).format('DD MMM YY')
    },
    addDomainList: async function () {
      this.domainListAdding = true
      RestService.post(process.env.VUE_APP_APIURL + 'domains/list', JSON.stringify(this.domainList)).then(
        (result) => {
          if (!result.data.result) {
            alert(result.data.message)
            this.domainListAdding = false
            return
          }
          this.domainListAdding = false
          this.dialog = false
        },
        (e) => {
          console.log(e)
          this.error = 'Server Error.'
        }
      )
    },

    exclude: async function (domain) {
      const excludeFuc = (domain) => {
        domain.excludeFromCatching = !domain.excludeFromCatching
        const excludedObject = {
          id: domain.id,
          excludeFromCatching: domain.excludeFromCatching
        }
        RestService.post(process.env.VUE_APP_APIURL + 'domains/exclude', JSON.stringify(excludedObject))
          .then((data) => {
            // this.refreshDomain();
          },
            (e) => {
              console.log(e)
              this.error = 'Server Error.'
            }
          )
      }
      if (this.selectedDomain.length > 0) {
        this.selectedDomain.map((item) => {
          excludeFuc(item)
        })
      } else {
        excludeFuc(domain)
      }
    },
    editItem(item) {
      this.editedIndex = this.domains.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    async handleDeleteDomainEvent(domain) {

      // First assume that we have only one domain to delete.
      let confirmationMessage = 'Are you sure you want to delete this item?'
      let deleteDomains = [domain]

      // Check if we have multiple domains to delete and handle this case.
      if (this.selectedDomain.length > 1) {
        confirmationMessage = 'Are you sure you want to delete this items?'

        deleteDomains = this.selectedDomain
      }

      if (confirm(confirmationMessage)) {
        for (let i = 0; i < deleteDomains.length; i++) {
          await this.deleteDomainFetch(deleteDomains[i])
        }

        this.selectedDomain = []
      }
    },
    async deleteDomainFetch(domain) {
      RestService.post(process.env.VUE_APP_APIURL + 'domains/delete', JSON.stringify(domain))
        .then((result) => {
          if (result.data.result) {
            this.deleteFromDomains(domain)
            Vue.notify({
              title: 'Delete domain ' + domain.domain,
              text: result.data.message
            })
          } else {
            Vue.notify({
              title: 'Error on delete domain',
              text: result.data.message,
              type: 'error'
            })
          }
        },
          (e) => {
            console.log(e)
            this.error = 'Server Error.'
          }
        )
    },
    deleteFromDomains(domain) {
      const index = this.domains.map(tempDomain => tempDomain.id).indexOf(domain.id)
      this.domains.splice(index, 1)
    },
    handleSelectDomainEvent(item) {
      if (item.value) {
        this.selectedDomain.push(item.item)
      } else {
        this.selectedDomain = this.selectedDomain.filter(val => val.id !== item.item.id)
      }
    },
    handleSelectAllDomainsEvent(event) {
      if (event.value) {
        // Selected all case.
        this.selectedDomain = event.items
      } else {
        // Deselected all case.
        this.selectedDomain = []
      }
    },
    statusMessage(statusMessage) {
      const matches = statusMessage.match(/\[.+?\]/g)

      let time = ''

      if (matches) {
        time = matches[0].substring(
          matches[0].lastIndexOf('[') + 1,
          matches[0].lastIndexOf(']')
        )

        return 'Domain Lost ' + matches[1] + ': ' + moment(time).format('DD MMM YY HH:mm:ss')
      } else {
        return statusMessage
      }
    },
    formatDate(date) {
      if (date) {
        return moment(date).format('DD MMM YY')
      } else {
        return "-"
      }
    },
    handlePageNumberChanged(item) {
      this.pagination.page = item
    },
    handleItemsPerPageChanged(item) {
      this.pagination.itemsPerPage = item
    }
  }
}
</script>
